import React from 'react'
import Text from '../../Text'
import { RedText } from './Mandatory.style'

function Mandatory(){
  return <Text primary><RedText>*</RedText> These fields are important to us.</Text>
}

export default Mandatory